module.exports = __webpack_public_path__ + "img/box-unlockbudget.4e171b94.png";